const initialState = {
  totalAllPengajuanProduktif: [],
  totalSupervisorProduktif: [],
  totalMarketingProduktif: [],
  totalAreaManagerProduktif: [],
  totalCabangProduktif: [],
  totalPengajuanProduktif: null,
};

const dashboardUtamaProduktifReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_AMBIL_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        totalAllPengajuanProduktif: data,
      };
    case "SET_ALL_TOTAL_SUPERVISOR_PRODUKTIF":
      return {
        ...state,
        totalSupervisorProduktif: data,
      };
    case "SET_ALL_TOTAL_AREAMANAGER_PRODUKTIF":
      return {
        ...state,
        totalAreaManagerProduktif: data,
      };
    case "SET_ALL_TOTAL_MARKETING_PRODUKTIF":
      return {
        ...state,
        totalMarketingProduktif: data,
      };
    case "SET_ALL_TOTAL_CABANG_PRODUKTIF":
      return {
        ...state,
        totalCabangProduktif: data,
      };
    case "SET_ALL_TOTAL_PENGAJUAN":
      return {
        ...state,
        totalPengajuanProduktif: data,
      };

    default:
      return state;
  }
};
export default dashboardUtamaProduktifReducer;
